import { SINE_WAVEY } from 'app/views/home/webgl/particlesOptimised/core/kernels/sine';
import { SineGridPhase } from 'app/views/home/webgl/particlesOptimised/departments/spaces/phases/SineGridPhase';

/**
 * SineWaveGridWaveyPhase — FORK of SpacesDepartment._sineWaveGridWavey.
 *
 * VISUAL: the "rolling swell" sine grid — crest response grows linearly
 * with grid x (xYIncrease = rawX * xIncrease) inside a wider ±25 amplitude
 * band, with a gentler scale gain (0.7), so waves build from one side of
 * the box to the other.
 *
 * Reference order kept: the arm calls _startSine BEFORE overwriting the
 * tuning fields (both run synchronously inside the arm, so no tick ever
 * sees the stale tuning — order preserved for faithfulness only).
 */
export class SineWaveGridWaveyPhase extends SineGridPhase {
	public readonly name = 'SineWaveGridWavey';

	public start(): void {
		this._state.sineType = SINE_WAVEY;
		this.startSine();

		this._state.xIncrease = 5;
		this._state.maxSineX = 25;
		this._state.minSineX = -25;
		this._state.sineDirection = 1;
		this._state.sineYChange = 0.13;
		this._state.sinePlaySeed = 3;
	}
}
